module.exports = __webpack_public_path__ + "img/oxford-police-logo.e96ae496.jpg";